import { render, staticRenderFns } from "./ALPS2021AMAZSD82.vue?vue&type=template&id=3ea22d6a&scoped=true"
import script from "./ALPS2021AMAZSD82.vue?vue&type=script&lang=js"
export * from "./ALPS2021AMAZSD82.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea22d6a",
  null
  
)

export default component.exports